<template>
  <div class="wrapper">
    <el-card class="box-card" v-for="(card,index) in update.col.data">
      <div slot="header" class="clearfix">
        <div>{{$t('mis.activeTemplate.type')}}{{index+1}}</div>
        <div style="float: right">
          <el-button type="text" @click="addReward()">{{$t('mis.bt.add')}}</el-button>
          <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('mis.bt.delete')}}</el-button>
        </div>
      </div>
      <div class="text item">
        <el-form-item :label="$t('mis.activeTemplate.fieldTitle')" :required="true">
          <el-input v-model="card.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('mis.activeTemplate.fieldField')" :required="true">
          <el-input v-model="card.field"></el-input>
        </el-form-item>
        <el-form-item :label="$t('mis.activeTemplate.fieldType')" :required="true">
          <el-select  v-model="card.type" :placeholder="$t('mis.activeTemplate.fieldType')">
            <el-option v-for="(type,index) in typeList" :label="type.name" :value="type.value"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'task',
    props:["update"],
    methods: {
        addReward(){
            this.update.col.data.push({});
        },
        delReward(index){
            this.update.col.data.splice(index, 1);
        }
    },
    data () {
      return {
          typeList: [
              { name: window.$t('mis.activeTemplate.text'), value: "0" },
              { name: window.$t('mis.activeTemplate.img'), value: "1" },
          ],
      }
    }
  }
</script>


<!--activeTemplate:{
type:"活动类型",
url:"发布域名",
detail:"模块模板",
field:"广告属性",
fieldTitle:"属性名称",
fieldField:"属性编码",
fieldType:"属性类型",
text:"文字",
img:"图片",
title:"模板标题",
activeTime:"活动时间",
author:"发布人",
}-->
